import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import {
	DONE,
	IN_PROGRESS,
	TODO,
	UNDEFINED,
	statusCategoryForId,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types.tsx';

const appearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

export const toAppearance = (categoryId?: string) =>
	categoryId != null ? appearanceMap[statusCategoryForId(categoryId)] : appearanceMap[UNDEFINED];

export const StatusItem = ({ data }: { data: ListViewControllerData }) => (
	<Lozenge appearance={toAppearance(data.status?.categoryId)} isBold={isVisualRefreshEnabled()}>
		{data.status?.name}
	</Lozenge>
);
